<template>
  <div>
    <!-- Stats Card Horizontal -->
    <b-row>
      <b-col lg="12">

        <b-row>
          <b-col cols="12">
            <app-echart-line
              style="height: 350px;"
              :option-data="option"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, VBModal,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { Icon } from 'leaflet'
import AppEchartLine from '@/views/analyticscifi/analyticdetailfi2/garaphLineAG/AppEchartLineAG.vue'
import 'leaflet/dist/leaflet.css'
/* eslint-disable global-require */
// eslint-disable-next-line import/order
// import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: {

    // BCard,
    BRow,
    BCol,
    // BEmbed,
    AppEchartLine,
    // flatPickr,
    // flatPickr,
    // BDropdown,
    // BDropdownItem,
    // BDropdownDivider,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      revenueGenerated: {},
      name: [],
      items: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      option: {
        xAxisData: [],
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false },
            axisLabel: {
              hideOverlap: true,
              show: true,
              fontSize: 16,
              color: '#fff',
            },
          },
        ],
        series: [
          {
            name: 'รถเกิดอุบัติเหตุ',
            type: 'line',
            color: '#D1EAE7',
            showSymbol: false,
            smooth: 0.4,
            areaStyle: { // Add this property to create the area graph effect
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#D1EAE7', // top color
                }, {
                  offset: 1, color: 'rgba(0, 212, 255, 0)', // transparent color
                }],
                globalCoord: false, // coordinate system
              },
            },
            lineStyle: {
              color: '#D1EAE7',
              width: 2,
              shadowColor: 'rgba(185, 235, 229, 0.5)',
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
            },
            itemStyle: {
              color: '#D1EAE7',
              borderColor: 'rgba(185, 235, 229, 0.5)',
              borderWidth: 10,
              shadowBlur: 20,
              shadowColor: 'rgba(185, 235, 229, 0.5)',
            },
            data: [],
          },
          {
            name: 'งานก่อสร้างทาง',
            type: 'line',
            color: '#66C5D9',
            showSymbol: false,
            smooth: 0.4,
            areaStyle: { // Add this property to create the area graph effect
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#66C5D9', // top color
                }, {
                  offset: 1, color: 'rgba(0, 212, 255, 0)', // transparent color
                }],
                globalCoord: false, // coordinate system
              },
            },
            lineStyle: {
              color: '#66C5D9',
              width: 2,
              shadowColor: 'rgba(74, 193, 218, 0.5)',
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
            },
            itemStyle: {
              color: '#66C5D9',
              borderColor: 'rgba(74, 193, 218, 0.5)',
              borderWidth: 10,
              shadowBlur: 20,
              shadowColor: 'rgba(74, 193, 218, 0.5)',
            },
            data: [],
          },
          {
            name: 'การปิดกั้นทาง',
            type: 'line',
            color: '#7AD0D1',
            showSymbol: false,
            smooth: 0.4,
            areaStyle: { // Add this property to create the area graph effect
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#7AD0D1', // top color
                }, {
                  offset: 1, color: 'rgba(0, 212, 255, 0)', // transparent color
                }],
                globalCoord: false, // coordinate system
              },
            },
            lineStyle: {
              color: '#7AD0D1',
              width: 2,
              shadowColor: 'rgba(86, 207, 208 , 0.5)',
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
            },
            itemStyle: {
              color: '#7AD0D1',
              borderColor: 'rgba(86, 207, 208 , 0.5)',
              borderWidth: 10,
              shadowBlur: 20,
              shadowColor: 'rgba(86, 207, 208 , 0.5)',
            },
            data: [],
          },
          {
            name: 'รถจอดไหล่ทาง',
            type: 'line',
            color: '#24ffeb',
            showSymbol: false,
            smooth: 0.4,
            areaStyle: { // Add this property to create the area graph effect
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#24ffeb', // top color
                }, {
                  offset: 1, color: 'rgba(0, 212, 255, 0)', // transparent color
                }],
                globalCoord: false, // coordinate system
              },
            },
            lineStyle: {
              color: '#24ffeb',
              width: 2,
              shadowColor: 'rgba(36, 255, 235, 0.5)',
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
            },
            itemStyle: {
              color: '#24ffeb',
              borderColor: 'rgba(36, 255, 235, 0.5)',
              borderWidth: 10,
              shadowBlur: 20,
              shadowColor: 'rgba(36, 255, 235, 0.5)',
            },
            data: [],
          },
          {
            name: 'รถจอดเสีย',
            type: 'line',
            color: '#BEDAE6',
            showSymbol: false,
            smooth: 0.4,
            areaStyle: { // Add this property to create the area graph effect
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#BEDAE6', // top color
                }, {
                  offset: 1, color: 'rgba(0, 212, 255, 0)', // transparent color
                }],
                globalCoord: false, // coordinate system
              },
            },
            lineStyle: {
              color: '#BEDAE6',
              width: 2,
              shadowColor: 'rgba(153, 206, 229, 0.5)',
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
            },
            itemStyle: {
              color: '#BEDAE6',
              borderColor: 'rgba(153, 206, 229, 0.5)',
              borderWidth: 10,
              shadowBlur: 20,
              shadowColor: 'rgba(153, 206, 229, 0.5)',
            },
            data: [],
          },
          {
            name: 'รถย้อนศร',
            type: 'line',
            color: '#7AD0D1',
            showSymbol: false,
            smooth: 0.4,
            areaStyle: { // Add this property to create the area graph effect
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#7AD0D1', // top color
                }, {
                  offset: 1, color: 'rgba(0, 212, 255, 0)', // transparent color
                }],
                globalCoord: false, // coordinate system
              },
            },
            lineStyle: {
              color: '#7AD0D1',
              width: 2,
              shadowColor: 'rgba(59, 211, 213, 0.5)',
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
            },
            itemStyle: {
              color: '#7AD0D1',
              borderColor: 'rgba(59, 211, 213, 0.5)',
              borderWidth: 10,
              shadowBlur: 20,
              shadowColor: 'rgba(59, 211, 213, 0.5)',
            },
            data: [],
          },
          {
            name: 'รถบรรทุกเลนขวา',
            type: 'line',
            color: '#86B9CC',
            showSymbol: false,
            smooth: 0.4,
            areaStyle: { // Add this property to create the area graph effect
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#86B9CC', // top color
                }, {
                  offset: 1, color: 'rgba(0, 212, 255, 0)', // transparent color
                }],
                globalCoord: false, // coordinate system
              },
            },
            lineStyle: {
              color: '#86B9CC',
              width: 2,
              shadowColor: 'rgba(92, 175, 206, 0.5)',
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
            },
            itemStyle: {
              color: '#86B9CC',
              borderColor: 'rgba(92, 175, 206, 0.5)',
              borderWidth: 10,
              shadowBlur: 20,
              shadowColor: 'rgba(92, 175, 206, 0.5)',
            },
            data: [],
          },
          {
            name: 'รถขับมากกว่า 120 km/hr เลนขวา',
            type: 'line',
            color: '#4F98B9',
            showSymbol: false,
            smooth: 0.4,
            areaStyle: { // Add this property to create the area graph effect
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#4F98B9', // top color
                }, {
                  offset: 1, color: 'rgba(0, 212, 255, 0)', // transparent color
                }],
                globalCoord: false, // coordinate system
              },
            },
            lineStyle: {
              color: '#4F98B9',
              width: 2,
              shadowColor: 'rgba(40, 141, 186, 0.5)',
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
            },
            itemStyle: {
              color: '#4F98B9',
              borderColor: 'rgba(40, 141, 186, 0.5)',
              borderWidth: 10,
              shadowBlur: 20,
              shadowColor: 'rgba(40, 141, 186, 0.5)',
            },
            data: [],
          },
          {
            name: 'รถขับต่ำกว่า 90 km/hr เลนขวา',
            type: 'line',
            color: '#45BCDA',
            showSymbol: false,
            smooth: 0.4,
            areaStyle: { // Add this property to create the area graph effect
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#45BCDA', // top color
                }, {
                  offset: 1, color: 'rgba(0, 212, 255, 0)', // transparent color
                }],
                globalCoord: false, // coordinate system
              },
            },
            lineStyle: {
              color: '#45BCDA',
              width: 2,
              shadowColor: 'rgba(19, 198, 243, 0.5)',
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
            },
            itemStyle: {
              color: '#45BCDA',
              borderColor: 'rgba(19, 198, 243, 0.5)',
              borderWidth: 10,
              shadowBlur: 20,
              shadowColor: 'rgba(19, 198, 243, 0.5)',
            },
            data: [],
          },
        ],
      },

      // check: '',
      // date: {
      //   wid: 732,
      //   dateFrom: '',
      // },
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    // this.checkPhase()
    // this.setToday()
    this.graphAnalyticLine()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.graphAnalyticLine()
    }, 300000)
  },
  methods: {
    resetChart() {
      this.option.xAxisData.splice(0)
      this.option.series[0].data.splice(0)
      this.option.series[1].data.splice(0)
      this.option.series[2].data.splice(0)
      this.option.series[3].data.splice(0)
      this.option.series[4].data.splice(0)
      this.option.series[5].data.splice(0)
      this.option.series[6].data.splice(0)
      this.option.series[7].data.splice(0)
      this.option.series[8].data.splice(0)
    },

    graphAnalyticLine() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getLineGraphDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.xAxisData = []
            this.resetChart()
            this.xAxisData = response.data
            this.xAxisData.forEach(value => {
              this.option.xAxisData.push(value.Date_Name)
              this.option.series[0].data.push(value.car_accident) // รถเกิดอุบัติเหตุ
              this.option.series[1].data.push(value.road_construction) // งานก่อสร้างทาง
              this.option.series[2].data.push(value.road_block) // การปิดกั้นทาง
              this.option.series[3].data.push(value.car_stop) // จราจรล่าช้า และหยุดนิ่ง(รถจอดไหล่ทาง)
              this.option.series[4].data.push(value.car_breakdown) // รถจอดเสีย
              this.option.series[5].data.push(value.wrong_way) // รถย้อนศร
              this.option.series[6].data.push(value.truck_right) // รถบรรทุกเลนขวา
              this.option.series[7].data.push(value.over_speed) // รถขับมากกว่า 120 km/hr เลนขวา
              this.option.series[8].data.push(value.limit_speed) // รถขับต่ำกว่า 90 km/hr เลนขวา
            // console.log(1222, this.option)
            })
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getLineGraphDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.xAxisData = []
            this.resetChart()
            this.xAxisData = response.data
            this.xAxisData.forEach(value => {
              this.option.xAxisData.push(value.Date_Name)
              this.option.series[0].data.push(value.car_accident) // รถเกิดอุบัติเหตุ
              this.option.series[1].data.push(value.road_construction) // งานก่อสร้างทาง
              this.option.series[2].data.push(value.road_block) // การปิดกั้นทาง
              this.option.series[3].data.push(value.car_stop) // จราจรล่าช้า และหยุดนิ่ง(รถจอดไหล่ทาง)
              this.option.series[4].data.push(value.car_breakdown) // รถจอดเสีย
              this.option.series[5].data.push(value.wrong_way) // รถย้อนศร
              this.option.series[6].data.push(value.truck_right) // รถบรรทุกเลนขวา
              this.option.series[7].data.push(value.over_speed) // รถขับมากกว่า 120 km/hr เลนขวา
              this.option.series[8].data.push(value.limit_speed) // รถขับต่ำกว่า 90 km/hr เลนขวา
            // console.log(1222, this.option)
            })
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    // graphAnalyticLine() {
    //   axios.post('/getLineCountDetail', { wid: 825 })
    //     .then(response => {
    //       this.xAxisData = []
    //       this.xAxisData = response.data
    //       this.xAxisData.forEach(value => {
    //         this.option.xAxisData.push(value.Period_Name)
    //         this.option.series[0].data.push(value.Total_PCU)
    //       })
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },

    // checkPhase() {
    //   axios
    //     .post('/checkPhaseTraffic', { wid: 732 })
    //     .then(response => {
    //       this.check = response.data[0].PhaseNo
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },

    // setToday() {
    //   const p = new Date()
    //   const month = (`0${p.getMonth() + 1}`).slice(-2)
    //   const date = (`0${p.getDate()}`).slice(-2)
    //   const year = p.getFullYear()
    //   this.date.dateFrom = `${year}-${month}-${date}`
    //   // this.date.dateTo = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
    // },
    // setToday() {
    //   const p = new Date()
    //   const month = (`0${p.getMonth() + 1}`).slice(-2)
    //   const date = 1
    //   const year = p.getFullYear()
    //   const dateTo = (`0${p.getDate()}`).slice(-2)
    //   this.date.dateFrom = `${year}-${month}-${date}`
    //   this.date.dateTo = `${year}-${month}-${dateTo}`
    // },
  },
}
</script>

<style lang="scss" >
// @import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';

.style-chooser .vs__dropdown-toggle {
  border: 0px solid #000000 !important; /* Change #0000FF to the color you'd like on hover */
  background: #131313 !important;
}
.style-chooser .vs__dropdown-toggle .vs__search::placeholder {
  color: rgb(255, 255, 255);
  opacity: 1; /* ทำให้สีเห็นชัดเจนขึ้น */
}
.apexcharts-legend-text {
  color: rgb(210, 176, 255)
}

</style>
